// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Button } from "../../../../revvComponents";
// export default function AddProductColumn(props) {
class FieldTableData extends Component {
  state = {};

  componentDidMount() {}

  openTabledetails = () => {
    this.setState({});
  };

  getRowData = (rowData, colHeadersList) => (
    <tr>
      {colHeadersList.map(header => (
        <td>{rowData[header] ? rowData[header] : null}</td>
      ))}
    </tr>
  );

  render() {
    const tableCol = this.props.fieldsList.find(
      item => item.id === this.props.colId,
    );
    const colheaders = [];

    tableCol.meta.table.table_schema.column_order.forEach(colId => {
      colheaders.push(tableCol.meta.table.table_schema.label_map[colId].text);
    });
    const tableData =
      this.props.transformedData[this.props.rowindex][this.props.colId];
    // this.props.transformedData.forEach(field => {
    //   if (field[this.props.colId] && field.Id === this.props.rowData.Id) {
    //     tableData = field[this.props.colId];
    //   }
    // });

    return (
      <Fragment>
        <div className="fieldstable-data-wrapper">
          <div className="fieldstable-data-righpane-wrapper">
            <div className="fieldstable-data-righpane-section">
              <div className="fieldstable-data-header">
                <div>
                  <Button
                    className="fieldstable-data-add-btn"
                    data-test="fieldstable-data-add-btn"
                    onClick={this.props.onClose}>
                    <i>
                      <FontAwesomeIcon icon={["far", "angle-left"]} />
                    </i>
                    {tableCol.label}
                  </Button>
                </div>
              </div>
              <div>
                <table className="table table-bordered">
                  <thead>
                    <tr className="field-table-header">
                      {colheaders.map(colheader => (
                        <th scope="col">{colheader}</th>
                      ))}
                    </tr>
                  </thead>
                  {Array.isArray(tableData) && tableData.length > 0 ? (
                    <tbody>
                      {tableData.map(item => this.getRowData(item, colheaders))}
                    </tbody>
                  ) : (
                    <span className="table-span">
                      - no rows avilable to show -
                    </span>
                  )}
                </table>
              </div>
              <div />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { transformedData, fieldsList } = state.FieldsSettingStore;

  return {
    transformedData,
    fieldsList,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FieldTableData);
